import axios from 'axios';
import { queryClient } from '@/lib/queryClient';

const api = axios.create({
  baseURL: '/api',
  withCredentials: true, // send session cookie
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.response.use(
  (res) => {
    // Any successful write may change data some page has cached — mark every
    // cache stale so pages on screen background-refresh now and the rest
    // refetch on next visit. Cached copies still render instantly meanwhile,
    // so this costs no spinners, only a few extra requests after each save.
    const method = res.config.method?.toLowerCase() ?? 'get';
    if (method !== 'get' && method !== 'head') {
      queryClient.invalidateQueries();
    }
    return res;
  },
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== '/login') {
      // Session expired — redirect to login (but not if already there)
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
